import * as ConfigTypes from 'config/ConfigTypes';

import SweetAlert from 'sweetalert2';


export const showConfirmMsgDlg = ({ htmlMsg, formatMessage, cb }) => {
    SweetAlert.fire({
        //html: htmlMsg,
        text: htmlMsg,
        showConfirmButton: true,
        confirmButtonColor: ConfigTypes.COLOR_RED,
        confirmButtonText: formatMessage({ id: "customdata.okMsg" })
    }).then(result => {
        if (result.value) {
            cb();
        }
    });
}

export const confirmInputMsg = async (props) => {
    const { formatMessage, titleIntl, textInputIntl, emptyIntl,
        cb, confirmBtnClass = '', cancelBtnClass = '' } = props;

    const swalWithBootstrapButtons = SweetAlert.mixin({
        customClass: {
            cancelButton: "btn btn-outline-dark mx-1 pt-1 pb-1 fs-6",
            confirmButton: "btn btn-dark pt-1 pb-1 fs-6",
            input: "mt-1 fs-6 mb-2 input-sm"
        },
        buttonsStyling: false
    });

    swalWithBootstrapButtons.fire({
        // title: formatMessage({ id: titleIntl }),
        input: "email",
        showCancelButton: true,
        //buttonsStyling: true,
        cancelButtonText: formatMessage({ id: "common.cancel" }),
        confirmButtonText: formatMessage({ id: "common.ok" }),
        // confirmButtonColor: ConfigTypes.COLOR_RED,
        // cancelButtonColor: ConfigTypes.BLACK,
        html:
            '<div>' +
            '<div style="font-size:26px;margin-bottom:10px;font-weight:bold;">'
            + formatMessage({ id: titleIntl }) +
            '</div>' +
            '<div style="font-size:16px;text-align:left;">'
            + formatMessage({ id: textInputIntl }) +
            '</div>' +
            '</div>',
        inputValidator: (value) => {
            if (!value) return formatMessage({ id: emptyIntl });
            else cb(value);
        }
    });
}

export const isDemo = () => {
    if (!process.env.REACT_APP_SERVER
        || process.env.REACT_APP_SERVER === ConfigTypes.SERVER_DEMO) {
        return true;
    }
    return false;
}

export const isLocal = () => {
    if (window.location.origin === ConfigTypes.LOCAL_HOST) {
        return true;
    }
    return false;
}

export const getBaseName = () => {
    let baseName = "";
    if (process.env.REACT_APP_BASENAME) {
        baseName = process.env.REACT_APP_BASENAME;
    }
    if (isLocal()) baseName = "/";
    return baseName;
}

export const pubPath = () => {
    let baseName = getBaseName();
    if (baseName === "/") return "";
    return baseName;
}

export const isHome = () => {
    if (window.location.path === getBaseName()) return true;
    return false;
}

export const getApiUrl = () => {
    let origin = window.location.origin;
    let apiurl = `${origin}/flow2/api/initws`;
    if (process.env.REACT_APP_DEV) {
        console.log("SERVER=DEV");
        apiurl = `${ConfigTypes.DEMO_SERVER}/flow2/api/initws`;
    }
    console.log("API_URL: ", apiurl);
    return apiurl;
}

export const isAudio = () => {
    if (process.env.REACT_APP_LOUNGE
        && process.env.REACT_APP_LOUNGE === ConfigTypes.AUDIO) return true;
    return false;
}

export const getStation = () => {
    let baseName = getBaseName();
    let stationName = "";
    if (baseName && baseName.includes(`${ConfigTypes.APP_NAME}`)) {
        stationName = baseName.split("-")[1];
    }
    console.log("LOGS: stationName", stationName);
    return stationName;
}

export const checkSearchApp = () => {
    if (process.env.REACT_APP_LOUNGE
        && process.env.REACT_APP_LOUNGE === ConfigTypes.SEARCH) return true;
    return false;
}



